import { Individualprofile, Publicprofile } from '@/payload-types'
import { ProfileCardComponent } from '@/components/public-profile-card/profileCard'

import Link from 'next/link'

interface IProps {
  profileData: (string | null) | Publicprofile
  customProfileCardCSS?: string
}

export const CompactPostProfileCard = ({ profileData, customProfileCardCSS }: IProps) => {
  let href = ''
  if (profileData && typeof profileData === 'object') {
    const entity =
      typeof profileData.profileEntity === 'object'
        ? (profileData.profileEntity as Individualprofile)
        : null
    const isProfessor = entity?.status?.toLowerCase().includes('professor')
    href = isProfessor ? `/professor/${profileData.slug}` : `/individual/${profileData.slug}`
  }
  return (
    <Link
      className={`flex flex-col items-center w-[116px] px-1 mb-3 ${customProfileCardCSS}`}
      href={href}
      target='_blank'
      prefetch={false}
    >
      <ProfileCardComponent
        profileData={profileData}
        profilePicture={{
          pictureDivCSS: 'h-20 w-20',
          pictureCSS: 'rounded-full shadow-md default-border',
        }}
        profileFullName={{
          fullNameDivCSS: 'text-center mt-1 !leading-[17.5px]',
          fullNameCSS: 'font-semibold text-sm !leading-[17.5px]',
        }}
      />
    </Link>
  )
}

export default CompactPostProfileCard
